import { InfosecLevel } from "~/resource/model/infosec-level";
import { cn } from "~/utils/cn";
import { isLightHexColor } from "~/utils/color";
import { formatInfosecLevelName } from "~/utils/infosec";

type ClassificationBannerSize = "sm" | "default";

interface ClassificationBannerProps {
  level: InfosecLevel;
  label: string;
  size?: ClassificationBannerSize;
  className?: string;
}

const sizeStyles: Record<ClassificationBannerSize, { container: string; label: string; level: string }> = {
  sm: {
    container: "h-6",
    label: "text-xs",
    level: "text-xs",
  },
  default: {
    container: "h-full",
    label: "text-xs",
    level: "text-sm",
  },
};

export function ClassificationBanner({ level, label, size = "default", className }: ClassificationBannerProps) {
  const styles = sizeStyles[size];
  const isLight = isLightHexColor(level.displayColor);

  return (
    <div
      className={cn(
        "group grid grid-cols-[1fr_auto_1fr] items-center rounded-sm px-3",
        styles.container,
        isLight && "border-border border",
        className,
      )}
      style={{ backgroundColor: level.displayColor }}
    >
      <span
        className={cn(
          "truncate font-mono opacity-0 transition-opacity duration-200 ease-out group-hover:opacity-100",
          isLight ? "text-foreground/60" : "text-white/60 drop-shadow-sm",
          styles.label,
        )}
      >
        {label}
      </span>
      <span className={cn("font-mono", isLight ? "text-foreground" : "text-white drop-shadow-sm", styles.level)}>
        {formatInfosecLevelName(level.name)}
      </span>
      <span />
    </div>
  );
}
